import { DefaultOptionType } from 'antd/lib/select';
import { SelectInput } from 'components/UI/FormItems/SelectInput';
import { FC } from 'react';
import { useGetConditionsQuery } from 'redux/services/animals/animalsApi';
import { useAppSelector } from 'redux/store';

interface Props {
  hideLabel?: boolean;
  fieldName: string;
  label: string;
}

export const ConditionsFieldInput: FC<Props> = ({ label, fieldName }) => {
  /* ******************** Hooks ******************** */
  const { animalsConditionsParams } = useAppSelector((state) => state);
  const { data: conditionsResponse, isLoading: isConditionsLoading } = useGetConditionsQuery(animalsConditionsParams);

  /* ******************** Variables ******************** */
  const conditionsOptions: DefaultOptionType[] | undefined = conditionsResponse?.data?.map((condition) => ({ value: condition.name, label: condition.name }));

  return (
    <SelectInput
      fieldName={fieldName}
      label={label}
      options={conditionsOptions}
      loading={isConditionsLoading}
      showSearch
      filterOption={(input, option): boolean => {
        if (typeof option?.value !== 'number') return (option?.value as string)?.toLowerCase().includes(input.toLowerCase());

        return false;
      }}
    />
  );
};
